"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNumberBaseType = exports.getTextFieldType = exports.isFormula = exports.isEnhanceTextType = exports.isTextBaseType = exports.isGroupFieldValid = exports.isSelectField = exports.isGroupFieldType = exports.isSelectType = exports.assertNever = void 0;
const field_types_1 = require("../types/field_types");
const constants_1 = require("../modules/shared/store/constants");
function assertNever(x) {
    throw new Error(`${x} is not a never type`);
}
exports.assertNever = assertNever;
function isSelectType(type) {
    return type === field_types_1.FieldType.MultiSelect || type === field_types_1.FieldType.SingleSelect;
}
exports.isSelectType = isSelectType;
function isGroupFieldType(type, viewType = constants_1.ViewType.Kanban) {
    switch (viewType) {
        case constants_1.ViewType.Grid: {
            // All grid fields can be grouped
            return true;
        }
        case constants_1.ViewType.Kanban: {
            return type === field_types_1.FieldType.SingleSelect || type === field_types_1.FieldType.Member;
        }
    }
    return false;
}
exports.isGroupFieldType = isGroupFieldType;
function isSelectField(field) {
    return isSelectType(field.type);
}
exports.isSelectField = isSelectField;
function isGroupFieldValid(snapshot, group, viewType) {
    if (viewType === constants_1.ViewType.Kanban && group.length > 1) {
        return false;
    }
    else if (viewType === constants_1.ViewType.Grid && group.length > 3) {
        return false;
    }
    return group.every(gp => {
        const field = snapshot.meta.fieldMap[gp.fieldId];
        return field && isGroupFieldType(field.type, viewType);
    });
}
exports.isGroupFieldValid = isGroupFieldValid;
function isTextBaseType(type) {
    return [field_types_1.FieldType.Text, field_types_1.FieldType.Phone, field_types_1.FieldType.Email, field_types_1.FieldType.URL, field_types_1.FieldType.SingleText].includes(type);
}
exports.isTextBaseType = isTextBaseType;
function isEnhanceTextType(type) {
    return [field_types_1.FieldType.Phone, field_types_1.FieldType.Email, field_types_1.FieldType.URL].includes(type);
}
exports.isEnhanceTextType = isEnhanceTextType;
function isFormula(type) {
    return type === field_types_1.FieldType.Formula;
}
exports.isFormula = isFormula;
function getTextFieldType(type) {
    return {
        isSingleText: type === field_types_1.FieldType.SingleText,
        isEnhanceText: isEnhanceTextType(type),
    };
}
exports.getTextFieldType = getTextFieldType;
function isNumberBaseType(type) {
    return [field_types_1.FieldType.Number, field_types_1.FieldType.Rating, field_types_1.FieldType.Currency, field_types_1.FieldType.Percent, field_types_1.FieldType.AutoNumber].includes(type);
}
exports.isNumberBaseType = isNumberBaseType;
//# sourceMappingURL=types.js.map